import { render, staticRenderFns } from "./OrganizationSlugEditor.vue?vue&type=template&id=8fc8e8a6"
import script from "./OrganizationSlugEditor.vue?vue&type=script&lang=js"
export * from "./OrganizationSlugEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports